<template>
  <!--会员中心页面-->
  <tk-container
    :status="status"
    :probeType="3"
    hide-status-bar
    class="member-center-bg"
    :style="`background-image: url(${bgSrc}) !important`"
    @refresh="refreshInit"
    @scroll="watchScroll"
    style="background: #fff;"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true" :is-header-color="isHeaderColor" :back-style="false" :icon-name="'return'">
      <div slot="center-menu" :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }">会员中心</div>
      <div
        slot="right-menu"
        style="font-size: 11px;margin-right: 8px !important;"
        @click="$push('/itsMine/memberRule')"
        :style="{ color: isHeaderColor ? '#000000' : '#fff' + '!important', zIndex: zIndex }"
      >会员规则</div>
    </gradient-header>
    <!--背景图渲染-->
    <div class="new-products-bg">
      <!--内容渲染-->
      <div class="m-12">
        <!--卡片渲染-->
        <div class="card-member p-b-15">
          <div class="member-level">{{levelName | membershipLevel}}</div>
          <tk-flex middle class="member-info">
            <tk-avatar size="50">
              <tk-image :src="avatarSrc" width="50" height="50"></tk-image>
            </tk-avatar>
            <div class="m-l-16">
              <div class="m-l-10">
                <div class="font-16 font-bold">{{fullName}}</div>
                <div class="m-t-2 font-12">{{'成长值：' + userGrowth}}</div>
              </div>
            </div>
          </tk-flex>
          <div class="m-x-15 m-t-20">
            <tk-flex right class="member-growth">
              {{userGrowth + '/' + levelGrowth}}
            </tk-flex>
            <div class="progress-bar m-t-10">
              <div class="progress" :style="{width: percentage + '%'}">
              </div>
            </div>
            <tk-flex between class="m-t-10">
              <div class="font-12 member-user">{{levelName | membershipLevel}}</div>
              <div class="font-12 member-growth">{{nextLevel | membershipLevel}}</div>
            </tk-flex>
          </div>
          <tk-flex center class="font-12 m-t-10 member-user">距离下一等级还需{{(levelGrowth - userGrowth)}}成长值</tk-flex>
        </div>
        <!--特权-->
        <tk-flex
          center middle
          class="m-t-20 p-t-15 m-b-24"
        >
          <tk-image :src="'https://s3.moke.cloud/dianpei/dc9b0007-1ef2-43ca-965b-69b1620a13e4.png'" height="13" width="16"></tk-image>
          <div class="p-x-15" :style="{color: 'rgba(184, 143, 87, 1)'}">会员尊享特权</div>
          <tk-image :src="'https://s3.moke.cloud/dianpei/dc9b0007-1ef2-43ca-965b-69b1620a13e4.png'" height="13" width="16"></tk-image>
        </tk-flex>
        <tk-flex
          wrap
          class="m-x-15 m-t-24"
        >
          <tk-flex
            center
            column
            class="tk-grid-3"
            v-for="(s, index) in privilegeList"
            :key="index"
          >
            <tk-avatar size="41">
              <tk-image :src="s.image" width="41" height="41"></tk-image>
            </tk-avatar>
            <div class="m-t-12 font-13" v-if="s.type === 'bean'">{{happyBeanSum + '欢乐豆'}}</div>
            <div class="m-t-12 font-13" v-else-if="s.type === 'check'">{{checkStarSum + '幸运星'}}</div>
            <div class="m-t-12 font-13" v-else>{{s.text}}</div>
            <div class="font-10 m-t-5 caption">{{s.explanation}}</div>
          </tk-flex>
        </tk-flex>
      </div>
    </div>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      privilegeList: [
        {
          image: 'https://s3.moke.cloud/dianpei/93968d0a-b8f9-4d96-8640-fffa978aadbe.png',
          text: '150欢乐豆',
          type: 'bean',
          explanation: '满100元可得'
        },
        {
          image: 'https://s3.moke.cloud/dianpei/5ccd739a-3d0e-4167-9079-34cbec69f939.png',
          text: ``,
          type: 'check',
          explanation: '签到1次可得'
        },
        {
          image: 'https://s3.moke.cloud/dianpei/33f74158-8e42-49c0-8ddf-b0285c04609f.png',
          text: '运费券',
          type: 'coupon',
          explanation: '运费补贴'
        },
        {
          image: 'https://s3.moke.cloud/dianpei/cbd6cfb8-1e61-43ce-9304-3fd2a1ba8f34.png',
          text: '优惠券',
          type: 'coupon',
          explanation: '满减优惠'
        }
      ]
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      return 'https://s3.moke.cloud/dianpei/acde86ff-f52b-4617-b0ed-e9899af38e40.png'
    },
    // 用户头像
    avatarSrc () {
      return this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
    },
    // 用户姓名
    fullName () {
      return this.userInfo.name ? this.userInfo.name : '用户'
    },
    // 用户当前成长值
    userGrowth () {
      if (!this.userInfo) { return 0 }
      return this.userInfo.growthValue ? this.userInfo.growthValue : 0
    },
    // 会员成长值：注册会员 -> 铜牌会员20000，铜牌 -> 银牌会员50000，银牌 -> 金牌会员100000，金牌 -> 钻石会员200000
    levelGrowth () {
      if (this.levelName === 'registeredMember') { return 20000 }
      if (this.levelName === 'bronzeMember') { return 50000 }
      if (this.levelName === 'silverMembers') { return 100000 }
      if (this.levelName === 'goldMembers') { return 200000 }
      if (this.levelName === 'diamondMembers') { return 9999999 }
      return 0
    },
    // 计算百分比
    percentage () {
      if (!this.userInfo.growthValue) { return 0 }
      let percent = Number(Number((this.userInfo.growthValue / this.levelGrowth) * 100).toFixed(2))
      if (percent > 99.99) { percent = 100 }
      return percent
    },
    // 下一级会员
    nextLevel () {
      if (this.levelName === 'registeredMember') { return 'bronzeMember' }
      if (this.levelName === 'bronzeMember') { return 'silverMembers' }
      if (this.levelName === 'silverMembers') { return 'goldMembers' }
      if (this.levelName === 'goldMembers') { return 'diamondMembers' }
      if (this.levelName === 'diamondMembers') { return 'diamondMembers' }
      return 'registeredMember'
    },
    // 会员订单每满100可得欢乐豆根据等级变化
    happyBeanSum () {
      if (!this.userInfo.accountCategory) { return 0 }
      if (this.userInfo.accountCategory !== 'countyAccount') { return 0 }
      if (this.levelName === 'registeredMember' || this.levelName === 'bronzeMember') { return 50 }
      if (this.levelName === 'silverMembers') { return 100 }
      if (this.levelName === 'goldMembers') { return 150 }
      if (this.levelName === 'diamondMembers') { return 200 }
      return 0
    },
    // 签到可得幸运星数量注册会员与铜牌会员赠送50，银牌会员赠送60，金牌会员赠送75，钻石会员赠送100
    checkStarSum () {
      if (!this.userInfo.accountCategory) { return 0 }
      if (this.userInfo.accountCategory !== 'countyAccount') { return 0 }
      if (this.levelName === 'registeredMember' || this.levelName === 'bronzeMember') { return 50 }
      if (this.levelName === 'silverMembers') { return 60 }
      if (this.levelName === 'goldMembers') { return 75 }
      if (this.levelName === 'diamondMembers') { return 100 }
      return 0
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        this.setStatusBar('light')
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      if (this.isHeaderColor) {
        this.setStatusBar('dark')
      } else {
        this.setStatusBar('light')
      }
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      await this.getInit()
    }
  }
}
</script>

<style scoped lang="scss">
  .member-center-bg {
    width: 100%;
    min-height: 190px;
    background-repeat: no-repeat !important;
    background-size: 100% 190px !important;
    background-attachment: fixed !important;
  }
  /*背景图样式*/
  .new-products-bg {
    padding-top: 70px;
  }
  /*会员信息样式*/
  .card-member {
    width: 100%;
    min-height: 190px;
    border-radius: 10px;
    position: relative;
    background: -webkit-linear-gradient(left, #f5e0bc, #e3b67a 75%);
    background: -o-linear-gradient(right, #f5e0bc, #e3b67a 75%);
    background: -moz-linear-gradient(right, #f5e0bc, #e3b67a 75%);
    background: linear-gradient(to right, #f5e0bc, #e3b67a 75%);
    box-shadow: 0 3px 2px 0 #f5e0bc;
    /*级别*/
    .member-level {
      width: 56px;
      height: 21px;
      border-radius:0 10px 0 10px;
      position: absolute;
      right: 0;
      top: 0;
      color: #D8A578;
      font-size: 11px;
      text-align: center;
      line-height: 21px;
      background:linear-gradient(90deg,rgba(246,220,181,1),rgba(250,242,223,1));
    }
    /*个人信息*/
    .member-info {
      margin-left: 38px;
      padding-top: 33px;
      color: rgba(166, 116, 48, 1);
    }
    /*进度条样式*/
    .progress-bar{
      /* 进度条的槽 */
      width:100%;
      /* 设置进度条的高度 */
      height: 5px;
      /*进度条外层div的背景色，进度未达到的地方的颜色 */
      background-color: rgba(250, 233, 206, 1);
      border-radius: 4px;
    }
    .progress{
      /* 进度部分 */
      /* 利用继承父元素宽度的百分比控制进度 */
      height: 100%;
      /* 内层背景色即进度达到的颜色 */
      background-color: rgba(171, 123, 60, 1) !important;
      border-radius: 4px;
    }
    .member-growth {
      color: rgba(243, 228, 204, 1);
    }
    .member-user {
      color: rgba(166, 116, 48, 1);
    }
  }
</style>
